<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <h2 class="font-semibold text-base text-gray-800 leading-tight">
                    <i class="fas fa-hand-holding-usd"></i>
                    Pagamento
                </h2>
            </div>
        </template>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <flash :timeout="5000" />

                <template>
                    <jet-form-section>
                        <template #title>
                            Validar boleto
                        </template>

                        <template #description>
                            Informe a linha digitável do boleto para iniciar o
                            pagamento
                        </template>

                        <template #form>
                            <div class="col-span-6">
                                <jet-label
                                    for="payer_mame"
                                    value="Linha digitável ou código de barras"
                                />
                                <div class="flex items-center mt-1">
                                    <input
                                        class="block w-full text-lg rounded-md border border-solid border-black text-gray-700 py-2 px-3"
                                        v-mask="[
                                            '###########-# ###########-# ###########-# ###########-#',
                                            '#####.##### #####.###### #####.###### # ##############'
                                        ]"
                                        v-model="form.base_code"
                                    />
                                    <jet-button
                                        :disabled="loading"
                                        @click.native="preview"
                                        class="py-4 ml-4 disabled:opacity-50"
                                    >
                                        &nbsp;<i
                                            :class="
                                                loading
                                                    ? 'fas fa-spinner fa-spin'
                                                    : 'fas fa-search'
                                            "
                                        ></i
                                        >&nbsp;
                                    </jet-button>
                                </div>
                                <div class="flex justify-end mt-5">
                                    <button
                                        v-if="
                                            form.boleto &&
                                                form.boleto.has_errors === false
                                        "
                                        @click="preValidateForm()"
                                        class="bg-green-500 text-xs hover:bg-green-700 text-white font-bold py-3 px-6 rounded uppercase"
                                    >
                                        {{
                                            escrow_account
                                                ? "Solicitar pagamento"
                                                : "Pagar"
                                        }}
                                    </button>
                                </div>
                            </div>
                        </template>
                    </jet-form-section>
                </template>

                <div v-if="form.boleto && form.boleto.has_errors === false">
                    <jet-section-border />
                    <template>
                        <jet-form-section>
                            <template #title>
                                Dados do boleto
                            </template>

                            <template #description>
                                Verifique corretamente os dados do boleto antes
                                de realizar o pagamento
                            </template>

                            <template #form>
                                <div class="col-span-6 sm:col-span-3">
                                    <jet-label value="Nome Beneficiário" />
                                    <div class="mt-2">
                                        {{ form.boleto.name }}
                                    </div>
                                </div>
                                <div class="col-span-6 sm:col-span-3">
                                    <jet-label value="Nome fantasia" />
                                    <div class="mt-2">
                                        {{ form.boleto.trade_name }}
                                    </div>
                                </div>

                                <div class="col-span-6 sm:col-span-3">
                                    <jet-label value="Documento" />
                                    <div class="mt-2">
                                        {{ form.boleto.document }}
                                    </div>
                                </div>
                                <div class="col-span-6 sm:col-span-3">
                                    <jet-label value="Valor do boleto" />
                                    <div class="mt-2">
                                        {{ form.boleto.amount }}
                                    </div>
                                </div>

                                <div class="col-span-6 sm:col-span-6">
                                    <hr class="w-full flex" />
                                </div>

                                <div class="col-span-6 sm:col-span-6">
                                    <div class="grid grid-cols-4 gap-4">
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtvencto"
                                                value="Dt. Vencimento"
                                            />
                                            <div class="mt-2">
                                                {{
                                                    form.boleto.due_date
                                                        | smallDate
                                                }}
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Dt. Pagamento"
                                            />
                                            <div class="mt-2">
                                                {{
                                                    form.boleto.payment_date
                                                        | smallDate
                                                }}
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="abatimento"
                                                value="Valor Abatimento"
                                            />
                                            <jet-decimal
                                                id="abatimento"
                                                class="mt-1 block w-full text-lg"
                                                v-model="
                                                    form.boleto.discount_amount
                                                "
                                            />
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="pagamento"
                                                value="Valor Pagamento"
                                            />
                                            <jet-decimal
                                                id="pagamento"
                                                class="mt-1 block w-full text-lg"
                                                v-model="
                                                    form.boleto.payment_amount
                                                "
                                            />
                                            <jet-input-error
                                                :message="
                                                    form.error(
                                                        'boleto.payment_amount'
                                                    )
                                                "
                                                class="mt-2"
                                            />
                                        </div>
                                    </div>
                                    <div class="grid grid-cols-4 gap-4">
                                        <div class="col-span-4">
                                            <jet-label
                                                for="pagamento"
                                                value="Descrição"
                                            />
                                            <jet-input
                                                id="description"
                                                class="mt-1 block w-full text-lg"
                                                v-model="form.description"
                                            />
                                            <jet-input-error
                                                :message="
                                                    form.error('description')
                                                "
                                                class="mt-2"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-span-6 sm:col-span-6">
                                    <hr class="w-full flex" />
                                </div>

                                <div class="col-span-6 sm:col-span-6">
                                    <div class="grid grid-cols-4 gap-4">
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtvencto"
                                                value="Cód. Multa"
                                            />
                                            <div class="mt-2">
                                                {{ form.boleto.interest_type }}
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Data"
                                            />
                                            <div
                                                v-if="form.boleto.interest_date"
                                                class="mt-2"
                                            >
                                                {{
                                                    form.boleto.interest_date
                                                        | smallDate
                                                }}
                                            </div>
                                            <div
                                                v-if="
                                                    !form.boleto.interest_date
                                                "
                                                class="mt-2"
                                            >
                                                -
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Valor"
                                            />
                                            <div class="mt-2">
                                                {{
                                                    form.boleto.interest_amount
                                                        | currency
                                                }}%
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Valor Calculado"
                                            />
                                            <div class="mt-2">
                                                R$
                                                {{
                                                    form.boleto.interest_amount
                                                        | currency
                                                }}
                                            </div>
                                        </div>

                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtvencto"
                                                value="Cód. Juros"
                                            />
                                            <div class="mt-2">
                                                {{ form.boleto.fine_type }}
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Data"
                                            />
                                            <div
                                                v-if="form.boleto.fine_date"
                                                class="mt-2"
                                            >
                                                {{
                                                    form.boleto.fine_date
                                                        | smallDate
                                                }}
                                            </div>
                                            <div
                                                v-if="!form.boleto.fine_date"
                                                class="mt-2"
                                            >
                                                -
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Valor"
                                            />
                                            <div class="mt-2">
                                                {{
                                                    form.boleto.fine_value
                                                        | currency
                                                }}%
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Valor Calculado"
                                            />
                                            <div class="mt-2">
                                                R$
                                                {{
                                                    form.boleto.fine_amount
                                                        | currency
                                                }}
                                            </div>
                                        </div>

                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtvencto"
                                                value="Cód. Juros"
                                            />
                                            <div class="mt-2">
                                                {{ form.boleto.discount_type }}
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Data"
                                            />
                                            <div
                                                v-if="form.boleto.discount_date"
                                                class="mt-2"
                                            >
                                                {{
                                                    form.boleto.discount_date
                                                        | smallDate
                                                }}
                                            </div>
                                            <div
                                                v-if="
                                                    !form.boleto.discount_date
                                                "
                                                class="mt-2"
                                            >
                                                -
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Valor"
                                            />
                                            <div class="mt-2">
                                                {{
                                                    form.boleto.discount_value
                                                        | currency
                                                }}%
                                            </div>
                                        </div>
                                        <div class="col-span-1">
                                            <jet-label
                                                for="dtpagto"
                                                value="Valor Calculado"
                                            />
                                            <div class="mt-2">
                                                R$
                                                {{
                                                    form.boleto.discount_amount
                                                        | currency
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </jet-form-section>
                    </template>
                </div>

                <div v-if="false" class="py-12">
                    <div class="bg-white shadow-xl sm:rounded-lg px-4 py-4">
                        <div class="flex justify-between">
                            <div class="flex items-center gap-4">
                                <h3 class="text-xl font-bold">
                                    Pagamentos em lote
                                </h3>
                                <span
                                    class="text-sm font-normal text-black text-opacity-60"
                                >
                                    {{ data?.pages?.totalItemCount ?? 0 }} planilha(s) importada(s)
                                </span>
                            </div>
                            <div>
                                <div class="flex justify-end">
                                    <button
                                        class="py-2 px-5 whitespace-nowrap w-min bg-yellow-400 text-black text-opacity-70 font-medium uppercase text-xs text-center rounded-md"
                                        @click="spreadsheetModal = true"
                                    >
                                        Importar planilha
                                    </button>
                                </div>
                                <a class="text-blue-500 text-xs underline" href="/modelo-2go_list.xlsx" download>
                                    Clique aqui para baixar o modelo da planilha
                                </a>
                            </div>
                        </div>

                        <inertia-table
                            class="text-gray-600 text-left"
                            :data="data"
                            :enableSearch="false"
                            :enable-display="true"
                            :columns="columns"
                            id="id"
                            routeName="payment.index"
                            @item-selected="show"
                        >
                            <template slot-scope="{ item }" slot="status">
                                <span
                                    :class="getStatus(item.status).bg"
                                    class="whitespace-nowrap font-semibold p-1.5 rounded-xl text-white text-xs"
                                >
                                    {{ getStatus(item.status).name }}
                                </span>
                            </template>
                            <template slot-scope="{ item }" slot="payment_date">
                                <span v-if="item.authorized" class="text-sm">
                                    {{ item.authorized | smallDateTime }}
                                </span>
                                <span v-else class="text-gray-400 text-sm">
                                    Indisponível
                                </span>
                            </template>
                            <template slot-scope="{ item }" slot="name">
                                <span class="text-sm">
                                    {{ item.name ?? '--'}}
                                </span>
                            </template>
                            <template slot-scope="{ item }" slot="amount">
                                <span class="text-sm">
                                    R$ {{ item.amount.paid | currency }}
                                    de
                                    <span class="text-xs text-gray-500">
                                        R$ {{ item.amount.value | currency }}
                                    </span>
                                </span>
                            </template>
                            <template slot-scope="{ item }" slot="failures">
                                <span
                                    class="text-sm font-bold"
                                    :class="
                                        item.failed.doc_count === 0
                                            ? 'text-black text-opacity-60'
                                            : 'text-red-500'
                                    "
                                >
                                    {{ item.failed.doc_count }}
                                </span>
                            </template>
                            <template slot-scope="{ item }" slot="paid">
                                <span
                                    class="text-sm font-bold"
                                    :class="
                                        item.paid.doc_count === 0
                                            ? 'text-black text-opacity-60'
                                            : 'text-green-500'
                                    "
                                >
                                    {{ item.paid.doc_count }}
                                </span>
                            </template>
                            <template slot-scope="{ item }" slot="total">
                                <span class="text-sm font-bold">
                                    {{ item.total.doc_count }}
                                </span>
                            </template>
                        </inertia-table>
                    </div>
                </div>
            </div>
            <!-- MODAL DE PAGAMENTO -->
            <jet-confirmation-modal
                v-if="form.boleto"
                :show="reviewPayment"
                @close="reviewPayment = false"
            >
                <template #title>
                    Confirme os dados
                </template>

                <template #content>
                    <template>
                        <jet-section-border />
                        <jet-form-section>
                            <template #title>
                                Dados do pagamento
                            </template>

                            <template #description>
                                Verifique se as informações estão corretas antes
                                de finalizar o pagamento
                            </template>

                            <template #form class=" gap-0">
                                <div class="col-span-6 sm:col-span-6">
                                    <table class="w-full">
                                        <template>
                                            <tr>
                                                <td class="px-2 py-2 text-sm">
                                                    <span
                                                        class="text-3xl font-extrabold"
                                                    >
                                                        R$
                                                        {{
                                                            form.boleto
                                                                .payment_amount
                                                        }}</span
                                                    ><br />
                                                    Para
                                                    <span class="font-bold">{{
                                                        form.boleto.name
                                                    }}</span>
                                                    <jet-input-error
                                                        :message="
                                                            form.error('amount')
                                                        "
                                                        class="mt-2"
                                                    />
                                                </td>
                                            </tr>
                                        </template>
                                    </table>
                                </div>
                            </template>
                        </jet-form-section>
                        <jet-section-border />
                        <jet-form-section>
                            <template #title>
                                Autenticação
                            </template>

                            <template #description>
                                Informe o código de autorização para autenticar
                                sua solicitação
                            </template>

                            <template #form>
                                <div class="col-span-6 sm:col-span-6">
                                    <jet-label
                                        for="google_code"
                                        value="Código de Autorização"
                                    />
                                    <jet-input
                                        id="google_code"
                                        type="number"
                                        class="mt-1 block w-full"
                                        v-model="form.google_code"
                                    />
                                    <jet-input-error
                                        :message="form.error('google_code')"
                                        class="mt-2"
                                    />
                                </div>
                            </template>
                        </jet-form-section>
                    </template>
                </template>

                <template #footer>
                    <jet-secondary-button @click.native="reviewPayment = false">
                        Agora não
                    </jet-secondary-button>
                    <!-- :disabled="form.processing" -->
                    <jet-ok-button
                        class="ml-2"
                        @click.native="pay"
                        :class="{ 'opacity-25': form.processing }"
                    >
                        Confirmar
                    </jet-ok-button>
                </template>
            </jet-confirmation-modal>

            <!-- MODAL PLANILHA -->
            <jet-confirmation-modal
                :show="spreadsheetModal"
                @close="spreadsheetModal = false"
                :widthContent="'w-full'"
                :position="'fixed'"
                :maxWidth="'xl'"
            >
                <template #title>
                    <span class="text-xl font-bold text-black text-opacity-70">
                        <em class="fas fa-arrow-left"></em>
                        Importar planilha
                    </span>
                    <jet-section-border class="-mt-6" />
                </template>

                <template #content>
                    <div class="flex flex-col items-start w-full">
                        <p class="text-xs text-gray-700 block mb-1 ml-2">
                            Selecione planilha (.xlsx)
                        </p>
                        <div class="flex items-center w-full space-x-5">
                            <div>
                                <input
                                    type="file"
                                    @change="handleFileEvent"
                                    ref="fileInput"
                                    class="hidden"
                                    accept=".xlsx"
                                />
                                <jet-secondary-button
                                    @click.native="selectFile"
                                    class="flex-shrink-0 whitespace-nowrap"
                                >
                                    <em
                                        class="fas fa-file-upload text-xs mr-2"
                                    ></em>
                                    Anexar documento
                                </jet-secondary-button>
                            </div>
                            <span
                                class="bg-gray-200 text-black text-opacity-40 px-4 py-2 flex-grow text-xs"
                            >
                                {{ fileName }}
                            </span>
                        </div>
                        <div
                            id="drop_zone"
                            class="bg-gray-200 text-black text-opacity-40 px-4 py-12 text-center rounded mt-5 w-full"
                            @dragover.prevent
                            @drop.prevent="handleFileEvent"
                        >
                            {{ dropMessage }}
                        </div>
                    </div>
                </template>

                <template #footer>
                    <div class="flex justify-between">
                        <jet-secondary-button
                            @click.native="spreadsheetModal = false"
                        >
                            Agora não
                        </jet-secondary-button>
                        <button
                            class="py-2 px-5 whitespace-nowrap w-min bg-yellow-400 text-black text-opacity-70 font-medium uppercase text-xs text-center rounded-md"
                            :class="{ 'opacity-25': formUploadXlsx.processing }"
                            :disabled="!formUploadXlsx.file"
                            @click="importSpreadsheet"
                        >
                            Confirmar
                        </button>
                    </div>
                </template>
            </jet-confirmation-modal>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import JetSectionBorder from "./../../Jetstream/SectionBorder";
import JetActionMessage from "../../Jetstream/ActionMessage";
import JetButton from "../../Jetstream/Button";
import JetFormSection from "../../Jetstream/FormSection";
import JetInput from "../../Jetstream/Input";
import JetTextarea from "../../Jetstream/Textarea";
import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import JetInputError from "../../Jetstream/InputError";
import JetLabel from "../../Jetstream/Label";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetMaskedInput from "../../Jetstream/MaskedInput";
import JetFetchDoc from "../../Jetstream/FetchDoc";
import JetDatePicker from "../../Jetstream/DatePicker";
import JetRadio from "../../Jetstream/Radio";
import JetDecimal from "../../Jetstream/Decimal";
import JetConfirmationModal from "../../Jetstream/ConfirmationModal";
import JetDangerButton from "../../Jetstream/DangerButton";
import JetOkButton from "../../Jetstream/OkButton";
import Flash from "../../Helpers/Flash";
import moment from "moment/dist/moment";
import InertiaTable from "../../Helpers/Tables/InertiaTable";

export default {
    props: ["boleto", "escrow_account", "data"],
    methods: {
        selectFile() {
            this.$refs.fileInput.click();
        },
        importSpreadsheet(){
            if(this.formUploadXlsx.processing) return

            this.formUploadXlsx.post('/payment/xlsx', {
                preserveState: true,
                onSuccess: () => {
                    this.spreadsheetModal = false;
                    this.resetFormXlsx()
                },
                onError: (e) => {
                    if(Array.isArray(e) && e.length){
                        this.$toast.error(e.join(''), {
                            position: 'top-right'
                        })
                    }
                    this.resetFormXlsx()
                },
            })
        },
        resetFormXlsx(){
            this.formUploadXlsx.reset()
            this.formUploadXlsx.processing = false;
            this.fileName = "Nenhum documento anexado";
            this.dropMessage = "Se preferir, arraste a planilha aqui.";
        },
        handleFileEvent(event) {
            let file;
            if (event.type === "change") {
                file = event.target.files[0];
            } else if (event.type === "drop") {
                const files = event.dataTransfer.files;
                if (files.length > 0) {
                    file = files[0];
                }
            }
            if (file) {
                if (
                    file.type ===
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                ) {
                    this.fileName = file.name;
                    this.dropMessage = file.name;
                    this.formUploadXlsx.file = file;
                } else {
                    this.$toast.open({
                        message: "Por favor, selecione um arquivo .xlsx",
                        type: "error",
                        duration: 5000,
                        position: "top-right"
                    });
                }
            }
        },
        preview(e) {
            if (this.form.base_code.replace(/[^0-9]/g, "").length < 48) {
                this.form.barcode = this.form.base_code;
            } else {
                this.form.code = this.form.base_code;
            }
            if (!this.form.code && !this.form.barcode) {
                return;
            }
            this.search(this);
        },
        search: _.debounce(vm => {
            vm.loading = true;
            fetch(
                `/json/payment?code=${escape(vm.form.code)}&barcode=${escape(
                    vm.form.barcode
                )}`
            ).then(res => {
                res.json().then(json => {
                    vm.form.boleto = json;
                    if (json.has_errors) {
                        vm.$toast.open({
                            message: json.message,
                            type: "error",
                            duration: 5000,
                            position: "top-right"
                        });
                    }
                });
                vm.loading = false;
            });
        }, 50),
        pay() {
            if (this.form.processing) return;
            const endpoint = "/payment";
            this.form._method = "POST";
            this.form.post(endpoint, {
                resetOnSuccess: true,
                onError: e => {
                    this.form.processing = false;
                }
            });
        },
        preValidateForm() {
            this.form.errors = {};
            this.reviewPayment = true;
            if (Object.keys(this.form.errors).length) {
                return false;
            }
            return true;
        },
        getStatus(status) {
            const status_ = {
                pending: { bg: "bg-yellow-500", name: "Pronto para pagar" },
                processing: { bg: "bg-blue-500", name: "Em execução" },
                paid: { bg: "bg-green-500", name: "Pago" }
            }[status];
            return (
                status_ || { bg: "bg-gray-300 text-black", name: "Indefinido" }
            );
        },
        show(item) {
            this.$inertia.get(route("payment.show", item.id));
        }
    },
    data() {
        return {
            moment: moment,
            spreadsheetModal: false,
            fileName: "Nenhum documento anexado",
            dropMessage: "Se preferir, arraste a planilha aqui.",
            flashIsVisible: true,
            reviewPayment: false,
            loading: false,
            formUploadXlsx: this.$inertia.form({
                file: null
            }),
            form: this.$inertia.form(
                {
                    code: "",
                    barcode: "",
                    base_code: "",
                    boleto: null,
                    description: null,
                    has_errors: null,
                    google_code: null
                },
                {
                    resetOnSuccess: false
                }
            ),
            columns: [
                {
                    text: "Status",
                    key: "status",
                    className: "text-left",
                    sortable: false
                },
                {
                    text: "Data do pagamento",
                    key: "payment_date",
                    className: "text-left",
                    sortable: false
                },
                {
                    text: "Nome",
                    key: "name",
                    className: "text-left",
                    sortable: false
                },
                {
                    text: "Valor pago",
                    key: "amount",
                    className: "text-left",
                    sortable: false
                },
                {
                    text: "Falhas",
                    key: "failures",
                    className: "text-left",
                    sortable: false
                },
                {
                    text: "Pagos",
                    key: "paid",
                    className: "text-left",
                    sortable: false
                },
                {
                    text: "Total",
                    key: "total",
                    className: "text-left",
                    sortable: false
                }
            ],
            interestTypes: [
                { id: "1", name: "Valor fixo" },
                { id: "2", name: "Percentual ao dia" },
                { id: "3", name: "Percentual ao mês" },
                { id: "5", name: "Isento" }
            ],
            fineTypes: [
                { id: "1", name: "Valor fixo" },
                { id: "2", name: "Percentual" },
                { id: "3", name: "Isenta" }
            ],
            discountTypes: [
                { id: "0", name: "Isento" },
                { id: "1", name: "Valor fixo" },
                { id: "2", name: "Percentual" },
                { id: "3", name: "Valor por antecipação" },
                { id: "5", name: "Percentual por antecipação" }
            ]
        };
    },
    components: {
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetRadio,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
        JetDatePicker,
        JetDecimal,
        JetConfirmationModal,
        JetDangerButton,
        JetOkButton,
        InertiaTable
    }
};
</script>
<style scoped>
button:disabled {
    background: rgb(172, 172, 172);
    opacity: 0.4;
    color: black;
    cursor: not-allowed;
}
</style>
